export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "";
export const NOTIFICATIONS_BASE_URL = import.meta.env.VITE_NOTIFICATIONS_BASE_URL || API_BASE_URL;

export const LAUNCHDARKLY_CLIENT_ID = import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID || "";
// The infra SSM param (/<env>/cognota/frontend/launchdarkly_client_id) ships a
// literal "unset" placeholder until the real client-side ID is written
// out-of-band. Treat that placeholder (and empty) as "not configured" so
// LaunchDarkly cleanly no-ops instead of initializing with a bogus ID and
// 404-ing on every flag fetch.
const LAUNCHDARKLY_UNCONFIGURED_IDS = new Set(["", "unset"]);
export const LAUNCHDARKLY_ENABLED =
  (import.meta.env.VITE_LAUNCHDARKLY_ENABLED ?? "true") !== "false" &&
  !LAUNCHDARKLY_UNCONFIGURED_IDS.has(LAUNCHDARKLY_CLIENT_ID);

export const USERPILOT_APP_ID = import.meta.env.VITE_USERPILOT_APP_ID || "";
